import axios from "axios";

export type ApplicationData = {
  email: string;
  name: string;
  linkedIn: string;
  file: File;
};

export default function useSubmitApplication(jobId: string) {
  return (content: ApplicationData, callback: (err: string | null) => void) => {
    // FormData is needed to support file upload
    const data = new FormData();

    data.append("email", content.email);
    data.append("name", content.name);
    data.append("linkedin", content.linkedIn);
    data.append("document", content.file);

    axios
      .post(
        `${process.env.NEXT_PUBLIC_BACKEND_URL}/jobs/${jobId}/applications`,
        data
      )
      .then(() => {
        callback(null);
      })
      .catch((err) => {
        console.log(err);

        callback(err.response?.data?.message);
      });
  };
}
